import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'
import { type } from 'os';

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  menu: [],
  locale: 'es',
  userVerified: false,
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null

    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_MENU] (state, { menu }) {
    state.menu = menu
  },

  [types.SET_LOCALE] (state, locale) {
    state.locale = locale
  },

  [types.SET_USER_VERIFIED] (state, verified) {
    state.userVerified = verified
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.get('/api/user')

      commit(types.FETCH_USER_SUCCESS, { user: data })
      commit(types.SET_LOCALE, data.locale)
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  async updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  },

  async fetchMenu ({ commit }) {
    commit(types.FETCH_USER_MENU, { menu: [] })
    const { data } = await axios.get('/api/user/menu')
    commit(types.FETCH_USER_MENU, { menu: data })
  },

  setUserVerified ({ commit }, verified) {
    commit(types.SET_USER_VERIFIED, verified)
  }
}

// getters
export const getters = {
  authUser: state => state.user,
  authToken: state => state.token,
  authCheck: state => state.user !== null,
  userMenu: state => state.menu,
  locale: state => state.locale,
  userVerified: state => state.userVerified,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js